export const EVENT_TYPES = {
  all: "all",
  ccu_peak: "ccu_peak",
  wishlist_peak: "wishlist_peak",
  topseller_peak: "topseller_peak",
} as const;

export type EventType = (typeof EVENT_TYPES)[keyof typeof EVENT_TYPES];

export function getEventTypeSelectOptions() {
  return [
    { value: EVENT_TYPES.all, label: "All Events" },
    { value: EVENT_TYPES.ccu_peak, label: "CCU Peaks" },
    { value: EVENT_TYPES.wishlist_peak, label: "Wishlist Peaks" },
    { value: EVENT_TYPES.topseller_peak, label: "Top Sellers Peaks" },
  ];
}

export function normalizeEventType(raw: string | string[] | undefined): EventType {
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (
    value === EVENT_TYPES.ccu_peak ||
    value === EVENT_TYPES.wishlist_peak ||
    value === EVENT_TYPES.topseller_peak
  ) {
    return value;
  }
  return EVENT_TYPES.all;
}
